export default __webpack_public_path__ + "static/media/custom_dry_flow.2bab6950.jpg";